export interface Notification {
  id: number;
  isRead: boolean;
  readAt: string | null;
  createdOn: string;
  comment: NotificationComment;
}

export interface NotificationComment {
  id: number;
  targetId: number;
  targetType: string;
  commentText: string;
  createdBy: string;
  createdOn: string;
}

// Dashboard notification API response structure
export interface DashboardNotificationData {
  hasMore: boolean;
  unreadCount: number;
  notifications: Notification[];
}

export interface DashboardNotificationResponse {
  data: DashboardNotificationData;
  message: string;
  customValues: any;
}

// All notifications API response structure
export interface AllNotificationsData {
  totalNotifications: number;
  totalPages: number;
  pageSize: number;
  currentPage: number;
  notifications: Notification[];
}

export interface AllNotificationsResponse {
  data: AllNotificationsData;
  message: string;
  customValues: any;
}

// Mark as read API response structure
export interface MarkReadResponse {
  data: boolean;
  message: string;
  customValues: any;
}

// UI-specific interfaces
export interface NotificationSummary {
  unreadCount: number;
  hasMore: boolean;
  notifications: Notification[];
}
